<template>
  <Html>
    <Body>
      <FlashNotifications />
      <ToastNotifications />
      <div id="app">
        <b-overlay :show="showOverlay" @click="hideOverlay" variant="dark" opacity="0.4">
          <component :is="layout"></component>
        </b-overlay>
      </div>
    </Body>
  </Html>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { bootstrapApp } from '@motionelements/core/src/services/app.service';
import windowResizeMixin from '@motionelements/core/src/components/mixins/window-resize.mixin.js';
import productEventsMixin from '@motionelements/core/src/components/mixins/product-events.mixin.js';

export default {
  name: 'App',
  components: {
    FlashNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseFlashNotifications.vue'),
    ToastNotifications: () => import('@motionelements/core/src/components/ui/notifications/BaseToastNotifications.vue'),
  },
  mixins: [windowResizeMixin, productEventsMixin],
  computed: {
    ...mapGetters({
      userLanguage: 'user/languageCode',
    }),
    ...mapState({
      showOverlay: state => state.overlay.showOverlay,
      isLoaded: state => state.aiTools.isLoaded,
    }),
    layout() {
      // more stable to load async
      // does not fire '/' route, then fire again.
      return () => ({
        component: import('@/layouts/DefaultLayout.vue'),
      });
      // const defaultLayout = 'default';

      // return `${this.$route.meta.layout || defaultLayout}-layout`;
      // return 'default-layout';
    },
  },
  beforeCreate() {
    bootstrapApp(this);
  },
  mounted() {
    if (!process.server) {
      this.$audioPlayer.init();
    }
    if (!this.isLoaded) {
      this.getAiTools({ language: this.userLanguage });
    }
  },
  methods: {
    ...mapActions({
      getAiTools: 'aiTools/getAiTools',
    }),
    updateGoogleTagManager(info) {
      console.log('updateGoogleTagManager created : ', info);

      let memberType = 'member';
      if (info.artist) {
        memberType = 'artist';
      }
      if (info.admin) {
        memberType = 'admin';
      }
      if (info.reseller) {
        memberType = 'reseller';
      }

      this.$gtm.trackEvent({
        event: 'vue_root_created',
        userId: info.id,
        username: info.username,
        firstName: info.first_name,
        lastName: info.last_name,
        fullName: info.full_name,
        email: info.email,
        memberType: memberType,
        industry: info.industry,
        language: info.language,
        countryCode: info.country,
        jobFunction: info.job_function,
      });
    },
    hideOverlay() {
      this.$store.commit('overlay/hide');
    },
  },
};
</script>

<style lang="scss">
// DISABLED BUTTONS
button {
  &:disabled, &.btn.disabled {
    cursor: not-allowed !important;
  }
}

.b-tooltip {
  opacity: 1 !important;
}
</style>

<style lang="scss">
@import './assets/scss/search-page-2025.scss';
</style>
